import {action} from "mobx";
import codPaymentService from "../services/codPaymentService";
import appStore from "./appStore";

class codPaymentStore {
    @action getPendingPayments = async params => {
        const resultOfRequest = await codPaymentService.getPendingPayments(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getCanceledPayments = async params => {
        const resultOfRequest = await codPaymentService.getCanceledPayments(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getSuccessPayments = async params => {
        const resultOfRequest = await codPaymentService.getSuccessPayments(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getPastPeriods = async params => {
        const resultOfRequest = await codPaymentService.getPastPeriods(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action addPaymentToReference = async params => {
        const resultOfRequest = await codPaymentService.addPaymentToReference(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getPendingInvoicePayments = async params => {
        const resultOfRequest = await codPaymentService.getPendingInvoicePayments(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action excelExportPendingInvoicePayments = async params => {
        const resultOfRequest = await codPaymentService.excelExportPendingInvoicePayments(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action assignInvoiceToPayment = async params => {
        const resultOfRequest = await codPaymentService.assignInvoiceToPayment(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action approvePayment = async params => {
        const resultOfRequest = await codPaymentService.approvePayment(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getHasInvoicePayments = async params => {
        const resultOfRequest = await codPaymentService.getHasInvoicePayments(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getCompletedPayments = async params => {
        const resultOfRequest = await codPaymentService.getCompletedPayments(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getFailedPayments = async params => {
        const resultOfRequest = await codPaymentService.getFailedPayments(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getConvertedToCashPayments = async params => {
        const resultOfRequest = await codPaymentService.getConvertedToCashPayments(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getPaidByBothCashAndCardPayments = async params => {
        const resultOfRequest = await codPaymentService.getPaidByBothCashAndCardPayments(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action checkPaymentStatusOnPos = async params => {
        const resultOfRequest = await codPaymentService.checkPaymentStatusOnPos(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action approvePaymentReferences = async params => {
        const resultOfRequest = await codPaymentService.approvePaymentReferences(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        if (!resultOfRequest?.data?.success) {
            appStore.openErrorModal({
                content: resultOfRequest?.data?.errorReferences?.join(", ") || ""
            });
        }
        return false;
    };

    @action listCourierTerminals = async (params = {}) => {
        const resultOfRequest = await codPaymentService.listCourierTerminals(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return {
                rows: [],
                dataCount: 0
            };
        }
        return resultOfRequest.data;
    };

    @action paymentTypes = async params => {
        console.log("Store params:", params);

        // apiKey ve token kontrolü
        if (!params || !params.apiKey) {
            console.error("apiKey is missing in params:", params);
            return {codPaymentTypes: []}; // Boş bir sonuç döndür
        }

        const resultOfRequest = await codPaymentService.paymentTypes(params);
        console.log("Payment types result:", resultOfRequest);

        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getPaymentSummary = async params => {
        const resultOfRequest = await codPaymentService.getPaymentsSummary(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getPaymentSummaryList = async params => {
        const resultOfRequest = await codPaymentService.getPaymentsSummaryList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({ content: resultOfRequest.data.message });
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };
}

export default new codPaymentStore();
